import axios from "axios";

export default {
    namespaced: true,

    state: {
        customer: null,
    },

    mutations: {
        getProfileSuccess(state, customer) {
            state.customer = customer;
        },

        updateProfileSuccess(state, user) {
            this.state.auth.user = user;
            if (user && user.customer) {
                state.customer = user.customer;
            }
        },
    },

    actions: {
        find(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/customers/${id}`)
                    .then((res) => {
                        resolve(res.data.data.customer);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create(_, customerForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/customers", customerForm, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res.data.data.customer);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update(_, customerForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/customers/${customerForm.get("id")}`,
                        customerForm,
                        {
                            headers: { "Content-Type": "multipart/form-data" },
                        }
                    )
                    .then((res) => {
                        resolve(res.data.data.customer);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        changeEmail(_, emailChange) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/customers/${emailChange.id}/change-email`,
                        emailChange
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        syncLab(_, customerId) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/customers/sync-lab", { customer_id: customerId })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete(_, customerId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/customers/${customerId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore(_, customerId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/customers/${customerId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getUpcomingAppointment(_) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/customers/get-upcoming-appointment")
                    .then((res) => {
                        resolve(res.data.data.upcoming_appointments);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getProfile(_) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/customers/get-profile")
                    .then((res) => {
                        commit("getProfileSuccess", res.data.data.customer);
                        resolve(res.data.data.customer);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        updateProfile(_, customerForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `/customers/${customerForm.get("id")}/update-profile`,
                        customerForm
                    )
                    .then((res) => {
                        commit("updateProfileSuccess", res.data.data.user);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getLastDocument(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/customers/last-document-by-appointment/${id}`)
                    .then((res) => {
                        resolve(res.data.data.document);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDecryptedDocument(_, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/customers/decrypt-document', payload, { responseType: 'blob' })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        uploadDocument(_, documentForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/customers/documents", documentForm, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res.data.data.document);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDemographics(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/customers/demographics-by-appointment/${id}`)
                    .then((res) => {
                        resolve(res.data.data.demographics);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        saveDemographics(_, demographicsForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/customers/demographics", demographicsForm)
                    .then((res) => {
                        resolve(res.data.data.demographics);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        customer: (state) => state.customer,
    },
};
